export default "__VITE_ASSET__BCo_LfZj__"